import { useEffect } from 'react';
import { getRecaptchaToken } from '../helpers/reCaptcha';
import { logger } from '@dist-marketplace-frontend/services';

export function useImproveRecaptchaEfficiency(key: string) {
  // Creating tokens (even when not used like here) improves recaptcha efficiency
  // See https://distilledsch.tpondemand.com/restui/board.aspx?#page=userstory/81733
  useEffect(() => {
    getRecaptchaToken(key).catch((error) => {
      logger.info({
        error,
        message: 'Passive recaptcha token generation failed',
        tags: ['RECAPTCHA'],
        customData: {
          key,
        },
      });
    });
  }, [key]);
}
